import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "@pillar-ui/icons";
import IndependenceDay1 from "../assets/thumbnails/thumbnail-1.png";
import IndependenceDay2 from "../assets/thumbnails/thumbnail-2.png";
import IndependenceDay3 from "../assets/thumbnails/thumbnail-3.png";
import IndependenceDay4 from "../assets/thumbnails/thumbnail-4.png";
import Halloween1 from "../assets/thumbnails/halloween-1.png";
import Halloween2 from "../assets/thumbnails/halloween-2.png";
import Halloween3 from "../assets/thumbnails/halloween-3.png";
import LunarNewYear1 from "../assets/thumbnails/tet-1.jpg";
import LunarNewYear2 from "../assets/thumbnails/tet-2.jpg";
import LunarNewYear3 from "../assets/thumbnails/tet-3.jpg";
import LunarNewYear4 from "../assets/thumbnails/tet-4.png";
import { IconButton, Paper } from "@pillar-ui/core";
import colors from "../styles/colors";
import { checkHoliday } from "../common/utils";

let thumbnailList = [];
(() => {
  const holiday = checkHoliday();

  switch (holiday) {
    case "independence":
      thumbnailList = [
        IndependenceDay1,
        IndependenceDay2,
        IndependenceDay3,
        IndependenceDay4,
      ];
      break;
    case "halloween":
      thumbnailList = [Halloween1, Halloween2, Halloween3];
      break;
    case "lunar":
      thumbnailList = [
        LunarNewYear1,
        LunarNewYear2,
        LunarNewYear3,
        LunarNewYear4,
      ];
      break;
    default:
  }
})();

const Carousel = () => {
  const [current, setCurrent] = useState(0);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? thumbnailList.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev === thumbnailList.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const slideInterval = setTimeout(() => {
      nextSlide();
    }, 4000);

    return () => clearTimeout(slideInterval);
  }, [current]);

  if (thumbnailList.length <= 0) return null;
  return (
    <Paper
      elevation={3}
      corner="2"
      width="100%"
      style={{
        aspectRatio: 2.5,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Slides container */}
      <Paper
        style={{
          display: "flex",
          height: "100%",
          width: `${thumbnailList.length * 100}%`,
          transform: `translateX(-${current * (100 / thumbnailList.length)}%)`,
          transition: "transform 0.5s ease",
        }}
      >
        {thumbnailList.map((imgSrc, index) => (
          <Paper
            key={index}
            width="100%"
            background="B9"
            style={{
              aspectRatio: 2.5,
              overflowY: "auto" /* Enable scrolling */,
              scrollbarWidth: "none" /* Firefox */,
              msOverflowStyle: "none" /* IE and Edge */,
            }}
          >
            <img src={imgSrc} width="100%" alt={imgSrc} />
          </Paper>
        ))}
      </Paper>

      {/* Controls */}
      <Paper onClick={prevSlide}>
        <IconButton
          variant="soft"
          color="se"
          style={{
            position: "absolute",
            top: "50%",
            left: "10px",
            transform: "translateY(-50%)",
            opacity: 0.3,
            height: 100,
          }}
          icon={<ChevronLeft color={colors.black} width={30} height={30} />}
        />
      </Paper>

      <Paper onClick={nextSlide}>
        <IconButton
          variant="soft"
          color="se"
          style={{
            position: "absolute",
            top: "50%",
            right: "10px",
            transform: "translateY(-50%)",
            opacity: 0.3,
            height: 100,
          }}
          icon={<ChevronRight color={colors.black} width={30} height={30} />}
        />
      </Paper>

      {/* Dots */}
      <Paper
        style={{
          position: "absolute",
          bottom: "10px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "8px",
        }}
      >
        {thumbnailList.map((_, index) => (
          <Paper
            key={index}
            onClick={() => setCurrent(index)}
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              cursor: "pointer",
              background: current === index ? "#3b82f6" : "#d1d5db",
            }}
          />
        ))}
      </Paper>
    </Paper>
  );
};

export default Carousel;
